import { render, staticRenderFns } from "./AdminFeatures.vue?vue&type=template&id=d896a604&"
import script from "./AdminFeatures.vue?vue&type=script&lang=js&"
export * from "./AdminFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports